// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IModuleI18n } from '@platform/core/types/modularity/IModuleI18n';
import type { IModuleManifest } from '@platform/core/types/modularity/IModuleManifest';

/** Пакет модуля «Менторство» (Mentoring, ключ `mentor`, група `development`). */
export const mentoringManifest: IModuleManifest = {
  key: 'mentor',
  group: 'development',
  slug: 'mentoring',
  prefix: 'MNT',
  name: { en: 'Mentoring', uk: 'Менторство' },
  entities: [
    { key: 'mentor', slug: 'mentor', name: { en: 'Mentoring pairs', uk: 'Менторські пари' }, main: true },
    { key: 'msess', slug: 'msess', name: { en: 'Mentoring sessions', uk: 'Менторські сесії' }, main: false },
  ],
  loadState: () => import('./state/mentoringSlice').then((m) => m.mentoringSlice),
  loadI18n: (lng) => (lng === 'uk' ? import('./i18n/uk.json') : import('./i18n/en.json')).then((m) => m.default as IModuleI18n),
  loadDefinition: () => import('./definition').then((m) => m.definition),
};
